import { render, staticRenderFns } from "./brick_generic_modelgenerator_subcomponent_caruana.vue?vue&type=template&id=d6b49eb6&"
import script from "./brick_generic_modelgenerator_subcomponent_caruana.vue?vue&type=script&lang=js&"
export * from "./brick_generic_modelgenerator_subcomponent_caruana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports